import styled from "styled-components";

const Video = styled.video`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
`;

export default function Vote() {
  return (
    <Video autoPlay muted loop playsInline>
      <source src="/video/vote.mp4" type="video/mp4" />
    </Video>
  );
}
